import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-enterprice-sass-footer',
  templateUrl: './enterprice-sass-footer.component.html',
  styleUrls: ['./enterprice-sass-footer.component.scss']
})
export class EnterpriceSassFooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
